module.exports = __webpack_public_path__ + "placa_ar_10x_s_1x9_carne.png?8f5ef5c9cfadc637d01fe467a04971d2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/placa_ar_10x_s_1x9_carne.png
// module id = 118
// module chunks = 0